import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Principal } from 'src/app/core/auth/principal.service';

/**
 * @whatItDoes Conditionally includes an HTML element if current user has any
 * of the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *jhiStaffAuthority="'brokerManagement'">...</some-element>
 *
 *     <some-element *jhiStaffAuthority="['brokerManagement', 'userManagement']">...</some-element>
 * ```
 */
@Directive({
    selector: '[jhiStaffHasAnyAuthority]'
})
export class StaffHasAnyAuthorityDirective { // to check having any authority is true return true
    private authorities: string[];

    constructor(private principal: Principal, private templateRef: TemplateRef<any>, private viewContainerRef: ViewContainerRef) {}

    @Input()
    set jhiStaffHasAnyAuthority(value: string | string[]) {
        this.authorities = typeof value === 'string' ? [value] : value;
        this.updateView();
        // Get notified each time authentication state changes.
        this.principal.getAuthenticationState().subscribe(identity => this.updateView());
    }

    private updateView(): void {
        let promiseAr:Promise<boolean>[]=[];

        this.authorities.forEach(auth=>{
            promiseAr.push(this.principal.hasStaffPermission(auth));  // getting result for all authorities
        })

        Promise.all(promiseAr).then(result=>{
            const isTrue = result.reduce((p1,p2)=>p1 || p2);  // checking common result 
            if(isTrue){
                this.viewContainerRef.clear();
                if (result) {
                    this.viewContainerRef.createEmbeddedView(this.templateRef);
                }
            }
        })

        // this.principal.hasStaffPermission(this.authorities[0]).then(result => {
        //     this.viewContainerRef.clear();
        //     if (result) {
        //         this.viewContainerRef.createEmbeddedView(this.templateRef);
        //     }
        // });
    }
}
